import { KeyboardEvent, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { HRM2130_R01Content } from "./Content_HRM2130_R01";
import { HRM2130_R01Dto } from "./Dto_HRM2130_R01";
import { HRM2130_R01SearchSection } from "./SearchSection_HRM2130_R01";
import { Table_HRM2130_R01 } from "./Table_HRM2130_R01";

/**
 * 화면의 액션바, 검색 영역, 편집 그리드, 메시지를 조립한다.
 * @returns HRM2130_R01 화면 JSX
 */
export const Container_HRM2130_R01 = () => {
    const gridRef = useRef<AgGridReact<HRM2130_R01Dto>>(null);
    const { setMessage } = useUiuxStore();
    // 자동 조회는 하지 않으며, 빈 목록에 입력용 빈 행을 넣는 처리는 Content가 담당한다.
    const {
        clickable, setClickable, fetchData,
        defaultHRM2130_R01Row, initContainerData, handleInsertClick,
        handleSaveClick, handleDeleteClick, handleExcelClick,
    } = HRM2130_R01Content({ gridRef, setMessage });

    // Content가 제공한 버튼 동작과 그리드 참조를 각 화면 요소에 연결한다.
    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onCreateClick={handleInsertClick}
                onDeleteClick={handleDeleteClick}
                onSaveClick={handleSaveClick}
                onExcelClick={handleExcelClick}
                onInitClick={initContainerData}
            />
            <HRM2130_R01SearchSection
                onEnterKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
                    // 근태명 입력에서 Enter를 누른 경우에만 조회한다.
                    if (event.key === 'Enter') void fetchData();
                }}
            />
            <div className="flex-1 flex">
                <div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
                    <Table_HRM2130_R01
                        clickable={clickable}
                        setClickable={setClickable}
                        gridRef={gridRef}
                        defaultHRM2130_R01Row={defaultHRM2130_R01Row()}
                        handleInsertClick={handleInsertClick}
                    />
                </div>
            </div>
            <Message />
        </div>
    );
};
